import React from "react";
import PropTypes from "prop-types";


export default function DockPanelHost({
  panel,
  active = true,
  onClose = null,
  onHide = null,
}) {
  if (!active) {
    return null;
  }

  return (
    <section
      className="studio-dock-panel"
      data-dock-panel-id={panel.id}
    >
      <header className="studio-dock-panel__header">
        <h3>{panel.title}</h3>

        <div className="studio-dock-panel__actions">
          {panel.hideable && onHide && (
            <button
              type="button"
              onClick={() => onHide(panel.id)}
              aria-label={`Masquer ${panel.title}`}
            >
              −
            </button>
          )}

          {panel.closable && onClose && (
            <button
              type="button"
              onClick={() => onClose(panel.id)}
              aria-label={`Fermer ${panel.title}`}
            >
              ×
            </button>
          )}
        </div>
      </header>

      <div className="studio-dock-panel__content">
        {panel.content}
      </div>
    </section>
  );
}


DockPanelHost.propTypes = {
  panel: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.node,
    closable: PropTypes.bool.isRequired,
    hideable: PropTypes.bool.isRequired,
  }).isRequired,
  active: PropTypes.bool,
  onClose: PropTypes.func,
  onHide: PropTypes.func,
};
